//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { CommonServices } from "@/services/CommonServices";
import * as OM from "@/Model";
import { baseUrl } from '@/config';
import { Router } from "vue-router";

class _AbuseClient {

  

  



    

    

    


  



  
  
  
  

  

  report(model : OM.ReportRequestVm, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Abuse/Report', model, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  closeAbuse(model : OM.CloseAbuseVm, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Abuse/CloseAbuse', model, { }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  



  
  
  
  



  

  getAllUserReport(pagedRequestVM: OM.PagedRequestVM, router: Router, showSpinner = true) : Promise<OM.PagedResponseOfAbuseRequest> {
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    pushHistoryState(pagedRequestVM, router);
    return CommonServices.defaultGet<OM.PagedResponseOfAbuseRequest>(baseUrl + 'api/Abuse/GetAllUserReport', paramsObject, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  



  
  
  
  



  

  getAllExperienceReport(pagedRequestVM: OM.PagedRequestVM, router: Router, showSpinner = true) : Promise<OM.PagedResponseOfAbuseRequest> {
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    pushHistoryState(pagedRequestVM, router);
    return CommonServices.defaultGet<OM.PagedResponseOfAbuseRequest>(baseUrl + 'api/Abuse/GetAllExperienceReport', paramsObject, showSpinner)
  }

  

  



  
  
  
  

  

  getAllOpened(showSpinner = true) : Promise<OM.AbuseRequest[]> {
    return CommonServices.defaultGet<OM.AbuseRequest[]>(baseUrl + 'api/Abuse/GetAllOpened', {  }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getReportDetail(reportIdentifier : string, showSpinner = true) : Promise<OM.AbuseRequestDetailVm> {
    return CommonServices.defaultGet<OM.AbuseRequestDetailVm>(baseUrl + 'api/Abuse/GetReportDetail', { reportIdentifier }, showSpinner)
  }
}
export let AbuseClient = new _AbuseClient();

class _ActivePlaceClient {

  

  



    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  



  
  
  
  



  

  getAll(pagedRequestVM: OM.PagedRequestVM, router: Router, showSpinner = true) : Promise<OM.PagedResponseOfActivePlaceVM> {
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    pushHistoryState(pagedRequestVM, router);
    return CommonServices.defaultGet<OM.PagedResponseOfActivePlaceVM>(baseUrl + 'api/ActivePlace/GetAll', paramsObject, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  canRegister(address : OM.Address, showSpinner = true) : Promise<boolean> {
    return CommonServices.defaultPost<boolean>(baseUrl + 'api/ActivePlace/CanRegister', address, { }, showSpinner)
  }

  

  



  
  
  
  

  

  getActivePlaceList(showSpinner = true) : Promise<OM.TranslateObject[]> {
    return CommonServices.defaultGet<OM.TranslateObject[]>(baseUrl + 'api/ActivePlace/GetActivePlaceList', {  }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  save(activePlaceVM : OM.ActivePlaceVM, showSpinner = true) : Promise<string> {
    return CommonServices.defaultPost<string>(baseUrl + 'api/ActivePlace/Save', activePlaceVM, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  disable(identifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/ActivePlace/Disable', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  publish(identifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/ActivePlace/Publish', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  hide(identifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/ActivePlace/Hide', { identifier }, showSpinner)
  }
}
export let ActivePlaceClient = new _ActivePlaceClient();

class _AppModalClient {

  

  



    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  



  
  
  
  



  

  getAll(pagedRequestVM: OM.PagedRequestVM, router: Router, showSpinner = true) : Promise<OM.PagedResponseOfAppModalVM> {
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    pushHistoryState(pagedRequestVM, router);
    return CommonServices.defaultGet<OM.PagedResponseOfAppModalVM>(baseUrl + 'api/AppModal/GetAll', paramsObject, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getById(identifier : string, showSpinner = true) : Promise<OM.AppModalVM> {
    return CommonServices.defaultGet<OM.AppModalVM>(baseUrl + 'api/AppModal/GetById', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  createOrUpdate(appModalVM : OM.AppModalVM, showSpinner = true) : Promise<string> {
    return CommonServices.defaultPost<string>(baseUrl + 'api/AppModal/CreateOrUpdate', appModalVM, { }, showSpinner)
  }

  

  



    

    

    

      

    

    

    


  



  
  
  
  

  

  updateAppModalImage(appModalIdentifier : string, file : File, progressFn: (prog) => void = null, showSpinner = true) : Promise<void> {
    return CommonServices.uploadFileToUrl<void>(baseUrl + 'api/AppModal/UpdateAppModalImage?appModalIdentifier=' + appModalIdentifier, file, { }, progressFn, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  publish(identifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/AppModal/Publish', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  hide(identifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/AppModal/Hide', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  disable(identifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/AppModal/Disable', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  enable(identifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/AppModal/Enable', { identifier }, showSpinner)
  }

  

  



  
  
  
  

  

  getAllVisibleOnApp(showSpinner = true) : Promise<OM.AppModalVM[]> {
    return CommonServices.defaultGet<OM.AppModalVM[]>(baseUrl + 'api/AppModal/GetAllVisibleOnApp', {  }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  readModal(modalIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/AppModal/ReadModal', { modalIdentifier }, showSpinner)
  }
}
export let AppModalClient = new _AppModalClient();

class _BackofficeLocalizationClient {

  

  



  
  
  
  

  

  getBackofficeDictionary(showSpinner = true) : Promise<OM.LocalizedEntity[]> {
    return CommonServices.defaultGet<OM.LocalizedEntity[]>(baseUrl + 'api/BackofficeLocalization/GetBackofficeDictionary', {  }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  



  
  
  
  



  

  getAll(pagedRequestVM: OM.PagedRequestVM, router: Router, showSpinner = true) : Promise<OM.PagedResponseOfLocalizedEntity> {
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    pushHistoryState(pagedRequestVM, router);
    return CommonServices.defaultGet<OM.PagedResponseOfLocalizedEntity>(baseUrl + 'api/BackofficeLocalization/GetAll', paramsObject, showSpinner)
  }
}
export let BackofficeLocalizationClient = new _BackofficeLocalizationClient();

class _BlockedUserClient {

  

  



    

    

    


  



  
  
  
  

  

  block(model : OM.BlockUserVM, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/BlockedUser/Block', model, { }, showSpinner)
  }

  

  



  
  
  
  

  

  getAll(showSpinner = true) : Promise<OM.BlockedUser[]> {
    return CommonServices.defaultGet<OM.BlockedUser[]>(baseUrl + 'api/BlockedUser/GetAll', {  }, showSpinner)
  }
}
export let BlockedUserClient = new _BlockedUserClient();

class _ChatClient {

  

  



  
  
  
  

  

  getAllChatRooms(showSpinner = true) : Promise<OM.ChatRoomListVM[]> {
    return CommonServices.defaultGet<OM.ChatRoomListVM[]>(baseUrl + 'api/Chat/GetAllChatRooms', {  }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getChatRoom(chatRoomIdentifier : string, showSpinner = true) : Promise<OM.ChatRoomVM> {
    return CommonServices.defaultGet<OM.ChatRoomVM>(baseUrl + 'api/Chat/GetChatRoom', { chatRoomIdentifier }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  



  
  
  
  

  

  getLast50Messages(chatRoomIdentifier : string, skip : number, showSpinner = true) : Promise<OM.ChatMessageVM[]> {
    return CommonServices.defaultGet<OM.ChatMessageVM[]>(baseUrl + 'api/Chat/GetLast50Messages', { chatRoomIdentifier, skip }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  sendMessage(chatMessage : OM.ChatMessageVM, showSpinner = true) : Promise<string> {
    return CommonServices.defaultPost<string>(baseUrl + 'api/Chat/SendMessage', chatMessage, { }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  



  
  
  
  




  

  getUserChatsFromBackoffice(pagedRequestVM: OM.PagedRequestWithIdentifierVM, router: Router, showSpinner = true) : Promise<OM.PagedResponseOfBackofficeChatListVM> {
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    pushHistoryState(pagedRequestVM, router);
    return CommonServices.defaultGet<OM.PagedResponseOfBackofficeChatListVM>(baseUrl + 'api/Chat/GetUserChatsFromBackoffice', paramsObject, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  



  
  
  
  



  

  getChatsFromBackoffice(pagedRequestVM: OM.PagedRequestVM, router: Router, showSpinner = true) : Promise<OM.PagedResponseOfBackofficeChatListVM> {
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    pushHistoryState(pagedRequestVM, router);
    return CommonServices.defaultGet<OM.PagedResponseOfBackofficeChatListVM>(baseUrl + 'api/Chat/GetChatsFromBackoffice', paramsObject, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getChatDetailFromBackoffice(identifier : string, showSpinner = true) : Promise<OM.BackofficeChatDetailVM> {
    return CommonServices.defaultGet<OM.BackofficeChatDetailVM>(baseUrl + 'api/Chat/GetChatDetailFromBackoffice', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getMessagesFromBackoffice(chatRoomIdentifier : string, showSpinner = true) : Promise<OM.ChatMessageVM[]> {
    return CommonServices.defaultGet<OM.ChatMessageVM[]>(baseUrl + 'api/Chat/GetMessagesFromBackoffice', { chatRoomIdentifier }, showSpinner)
  }
}
export let ChatClient = new _ChatClient();

class _DashboardClient {

  

  



  
  
  
  

  

  getDataDashAllUsersCount(showSpinner = true) : Promise<OM.DataDashAllUsersCountVM> {
    return CommonServices.defaultGet<OM.DataDashAllUsersCountVM>(baseUrl + 'api/Dashboard/GetDataDashAllUsersCount', {  }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  



  
  
  
  

  

  getHistorycalDataDashAllUserCount(startDateFilter : string, endDateFilter : string, showSpinner = true) : Promise<OM.DataDashAllUsersCountHistoryVM[]> {
    return CommonServices.defaultGet<OM.DataDashAllUsersCountHistoryVM[]>(baseUrl + 'api/Dashboard/GetHistorycalDataDashAllUserCount', { startDateFilter, endDateFilter }, showSpinner)
  }
}
export let DashboardClient = new _DashboardClient();

class _DeleteAccountReasonClient {

  

  



    

    

    


  



  
  
  
  

  

  create(deleteAccountReasonVM : OM.DeleteAccountReasonVM, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/DeleteAccountReason/Create', deleteAccountReasonVM, { }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  



  
  
  
  



  

  getAll(pagedRequestVM: OM.PagedRequestVM, router: Router, showSpinner = true) : Promise<OM.PagedResponseOfDeleteAccountReason> {
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    pushHistoryState(pagedRequestVM, router);
    return CommonServices.defaultGet<OM.PagedResponseOfDeleteAccountReason>(baseUrl + 'api/DeleteAccountReason/GetAll', paramsObject, showSpinner)
  }
}
export let DeleteAccountReasonClient = new _DeleteAccountReasonClient();

class _ExperienceAffinityClient {

  

  



    

    

    


  



  
  
  
  

  

  getExperienceAffinityDetail(experienceIdentifier : string, showSpinner = true) : Promise<OM.ExperienceAffinityDetailVM> {
    return CommonServices.defaultGet<OM.ExperienceAffinityDetailVM>(baseUrl + 'api/ExperienceAffinity/GetExperienceAffinityDetail', { experienceIdentifier }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  



  
  
  
  

  

  candidateToExperience(experienceIdentifier : string, affinityIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/ExperienceAffinity/CandidateToExperience', { experienceIdentifier, affinityIdentifier }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  



  
  
  
  

  

  removeMyApplicationFromExperience(affinityIdentifier : string, experienceIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/ExperienceAffinity/RemoveMyApplicationFromExperience', { affinityIdentifier, experienceIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  confirmAffinity(model : OM.ConfirmAffinityVM, showSpinner = true) : Promise<string> {
    return CommonServices.defaultPost<string>(baseUrl + 'api/ExperienceAffinity/ConfirmAffinity', model, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  confirmExperienceAffinity(model : OM.ExperienceConfirmAffinityVM, showSpinner = true) : Promise<string> {
    return CommonServices.defaultPost<string>(baseUrl + 'api/ExperienceAffinity/ConfirmExperienceAffinity', model, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  takeOffAffinity(affinityIdentifier : string, showSpinner = true) : Promise<OM.UserMatchQuestionResponse> {
    return CommonServices.defaultGet<OM.UserMatchQuestionResponse>(baseUrl + 'api/ExperienceAffinity/TakeOffAffinity', { affinityIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  refuseAffinity(affinityIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/ExperienceAffinity/RefuseAffinity', { affinityIdentifier }, showSpinner)
  }

  

  



  
  
  
  

  

  getExperienceManagement(showSpinner = true) : Promise<OM.ExperienceManagementVM> {
    return CommonServices.defaultGet<OM.ExperienceManagementVM>(baseUrl + 'api/ExperienceAffinity/GetExperienceManagement', {  }, showSpinner)
  }

  

  



  
  
  
  

  

  getMyApplications(showSpinner = true) : Promise<OM.ExperienceAffinityDetailVM[]> {
    return CommonServices.defaultGet<OM.ExperienceAffinityDetailVM[]>(baseUrl + 'api/ExperienceAffinity/GetMyApplications', {  }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getMyApplicationDetailByAffinityId(identifier : string, showSpinner = true) : Promise<OM.MyApplicationExperienceAffinityDetailVM> {
    return CommonServices.defaultGet<OM.MyApplicationExperienceAffinityDetailVM>(baseUrl + 'api/ExperienceAffinity/GetMyApplicationDetailByAffinityId', { identifier }, showSpinner)
  }

  

  



  
  
  
  

  

  checkIfUncompletedProfileUserCanCandidateToExperience(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/ExperienceAffinity/CheckIfUncompletedProfileUserCanCandidateToExperience', {  }, showSpinner)
  }

  

  



  
  
  
  

  

  checkIfCanReply(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/ExperienceAffinity/CheckIfCanReply', {  }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  



  
  
  
  

  

  getMatchDetail(affinityIdentifier : string, replierIdentifier : string, showSpinner = true) : Promise<OM.MatchDetailVm> {
    return CommonServices.defaultGet<OM.MatchDetailVm>(baseUrl + 'api/ExperienceAffinity/GetMatchDetail', { affinityIdentifier, replierIdentifier }, showSpinner)
  }

  

  



  
  
  
  

  

  getNewMatch(showSpinner = true) : Promise<OM.NewMatchVm> {
    return CommonServices.defaultGet<OM.NewMatchVm>(baseUrl + 'api/ExperienceAffinity/GetNewMatch', {  }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getNewMatchInformations(identifier : string, showSpinner = true) : Promise<OM.NewMatchVm> {
    return CommonServices.defaultGet<OM.NewMatchVm>(baseUrl + 'api/ExperienceAffinity/GetNewMatchInformations', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  replyQuestion(model : OM.ExperienceReplyMatchQuestionVm, showSpinner = true) : Promise<OM.NewMatchVm> {
    return CommonServices.defaultPost<OM.NewMatchVm>(baseUrl + 'api/ExperienceAffinity/ReplyQuestion', model, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  takeOffMultipleAffinitiesFromChatRoomIdentifiers(model : OM.TakeOffMultipleAffinitiesVM, showSpinner = true) : Promise<OM.UserMatchQuestionResponse> {
    return CommonServices.defaultPost<OM.UserMatchQuestionResponse>(baseUrl + 'api/ExperienceAffinity/TakeOffMultipleAffinitiesFromChatRoomIdentifiers', model, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getNewMatchFromBackoffice(userIdentifier : string, showSpinner = true) : Promise<OM.NewMatchVm> {
    return CommonServices.defaultGet<OM.NewMatchVm>(baseUrl + 'api/ExperienceAffinity/GetNewMatchFromBackoffice', { userIdentifier }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  



  
  
  
  




  

  getUserAffinitiesFromBackoffice(pagedRequestVM: OM.PagedRequestWithIdentifierVM, router: Router, showSpinner = true) : Promise<OM.PagedResponseOfBackofficeAffinityListVM> {
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    pushHistoryState(pagedRequestVM, router);
    return CommonServices.defaultGet<OM.PagedResponseOfBackofficeAffinityListVM>(baseUrl + 'api/ExperienceAffinity/GetUserAffinitiesFromBackoffice', paramsObject, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  



  
  
  
  



  

  getAffinitiesFromBackoffice(pagedRequestVM: OM.PagedRequestVM, router: Router, showSpinner = true) : Promise<OM.PagedResponseOfBackofficeAffinityListVM> {
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    pushHistoryState(pagedRequestVM, router);
    return CommonServices.defaultGet<OM.PagedResponseOfBackofficeAffinityListVM>(baseUrl + 'api/ExperienceAffinity/GetAffinitiesFromBackoffice', paramsObject, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getMatchDetailFromBackoffice(affinityIdentifier : string, showSpinner = true) : Promise<OM.BackofficeAffinityDetailVM> {
    return CommonServices.defaultGet<OM.BackofficeAffinityDetailVM>(baseUrl + 'api/ExperienceAffinity/GetMatchDetailFromBackoffice', { affinityIdentifier }, showSpinner)
  }
}
export let ExperienceAffinityClient = new _ExperienceAffinityClient();

class _ExperienceClient {

  

  



    

    

    


  



  
  
  
  

  

  experienceList(model : OM.ExperienceSearchVM, showSpinner = true) : Promise<OM.ExperienceDetailVM[]> {
    return CommonServices.defaultPost<OM.ExperienceDetailVM[]>(baseUrl + 'api/Experience/ExperienceList', model, { }, showSpinner)
  }

  

  



  
  
  
  

  

  myDraftList(showSpinner = true) : Promise<OM.MyExperienceDetailVM[]> {
    return CommonServices.defaultGet<OM.MyExperienceDetailVM[]>(baseUrl + 'api/Experience/MyDraftList', {  }, showSpinner)
  }

  

  



  
  
  
  

  

  myPendingList(showSpinner = true) : Promise<OM.MyExperienceDetailVM[]> {
    return CommonServices.defaultGet<OM.MyExperienceDetailVM[]>(baseUrl + 'api/Experience/MyPendingList', {  }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getAllActiveListByOwner(ownerIdentifier : string, showSpinner = true) : Promise<OM.ExperienceDetailVM[]> {
    return CommonServices.defaultGet<OM.ExperienceDetailVM[]>(baseUrl + 'api/Experience/GetAllActiveListByOwner', { ownerIdentifier }, showSpinner)
  }

  

  



  
  
  
  

  

  myActiveList(showSpinner = true) : Promise<OM.MyExperienceDetailVM[]> {
    return CommonServices.defaultGet<OM.MyExperienceDetailVM[]>(baseUrl + 'api/Experience/MyActiveList', {  }, showSpinner)
  }

  

  



  
  
  
  

  

  myActivePastList(showSpinner = true) : Promise<OM.MyExperienceDetailVM[]> {
    return CommonServices.defaultGet<OM.MyExperienceDetailVM[]>(baseUrl + 'api/Experience/MyActivePastList', {  }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getById(identifier : string, showSpinner = true) : Promise<OM.ExperienceDetailVM> {
    return CommonServices.defaultGet<OM.ExperienceDetailVM>(baseUrl + 'api/Experience/GetById', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getMyExperienceById(identifier : string, showSpinner = true) : Promise<OM.MyExperienceDetailVM> {
    return CommonServices.defaultGet<OM.MyExperienceDetailVM>(baseUrl + 'api/Experience/GetMyExperienceById', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  save(model : OM.ExperienceEditVM, showSpinner = true) : Promise<string> {
    return CommonServices.defaultPost<string>(baseUrl + 'api/Experience/Save', model, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  submitForApproval(experienceIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Experience/SubmitForApproval', { experienceIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  backToDraft(experienceIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Experience/BackToDraft', { experienceIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getAllExperienceCategories(allOptionIncluded : boolean, showSpinner = true) : Promise<OM.ExperienceCategory[]> {
    return CommonServices.defaultGet<OM.ExperienceCategory[]>(baseUrl + 'api/Experience/GetAllExperienceCategories', { allOptionIncluded }, showSpinner)
  }

  

  



    

    

    

      

    

    

    


  



  
  
  
  

  

  uploadAudio(experienceIdentifier : string, file : File, progressFn: (prog) => void = null, showSpinner = true) : Promise<void> {
    return CommonServices.uploadFileToUrl<void>(baseUrl + 'api/Experience/UploadAudio?experienceIdentifier=' + experienceIdentifier, file, { }, progressFn, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  deleteAudio(experienceIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Experience/DeleteAudio', { experienceIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  refuseExperience(experienceIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Experience/RefuseExperience', { experienceIdentifier }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  



  
  
  
  



  

  experiencePendingList(pagedRequestVM: OM.PagedRequestVM, router: Router, showSpinner = true) : Promise<OM.PagedResponseOfExperienceBackofficeListVM> {
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    pushHistoryState(pagedRequestVM, router);
    return CommonServices.defaultGet<OM.PagedResponseOfExperienceBackofficeListVM>(baseUrl + 'api/Experience/ExperiencePendingList', paramsObject, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  



  
  
  
  



  

  experienceApprovedList(pagedRequestVM: OM.PagedRequestVM, router: Router, showSpinner = true) : Promise<OM.PagedResponseOfExperienceBackofficeListVM> {
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    pushHistoryState(pagedRequestVM, router);
    return CommonServices.defaultGet<OM.PagedResponseOfExperienceBackofficeListVM>(baseUrl + 'api/Experience/ExperienceApprovedList', paramsObject, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  



  
  
  
  



  

  experienceRefusedList(pagedRequestVM: OM.PagedRequestVM, router: Router, showSpinner = true) : Promise<OM.PagedResponseOfExperienceBackofficeListVM> {
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    pushHistoryState(pagedRequestVM, router);
    return CommonServices.defaultGet<OM.PagedResponseOfExperienceBackofficeListVM>(baseUrl + 'api/Experience/ExperienceRefusedList', paramsObject, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  approveExperience(experienceIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Experience/ApproveExperience', { experienceIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  refuseExperienceBackoffice(model : OM.RefuseExperienceVm, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Experience/RefuseExperienceBackoffice', model, { }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  



  
  
  
  



  

  getAllExperiencesFromBackoffice(pagedRequestVM: OM.PagedRequestVM, router: Router, showSpinner = true) : Promise<OM.PagedResponseOfExperienceBackofficeListVM> {
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    pushHistoryState(pagedRequestVM, router);
    return CommonServices.defaultGet<OM.PagedResponseOfExperienceBackofficeListVM>(baseUrl + 'api/Experience/GetAllExperiencesFromBackoffice', paramsObject, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  



  
  
  
  




  

  getAllExperiencesByOwnerFromBackoffice(pagedRequestVM: OM.PagedRequestWithIdentifierVM, router: Router, showSpinner = true) : Promise<OM.PagedResponseOfExperienceBackofficeListVM> {
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    pushHistoryState(pagedRequestVM, router);
    return CommonServices.defaultGet<OM.PagedResponseOfExperienceBackofficeListVM>(baseUrl + 'api/Experience/GetAllExperiencesByOwnerFromBackoffice', paramsObject, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  backofficeGetByID(identifier : string, showSpinner = true) : Promise<OM.BackofficeExperienceDetailVM> {
    return CommonServices.defaultGet<OM.BackofficeExperienceDetailVM>(baseUrl + 'api/Experience/BackofficeGetByID', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  deleteExperience(identifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Experience/DeleteExperience', { identifier }, showSpinner)
  }
}
export let ExperienceClient = new _ExperienceClient();

class _FCMWebhookClient {

  

  



  
  
  
  

  

  receiveWebhook(showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/FCMWebhook/ReceiveWebhook', null, { }, showSpinner)
  }
}
export let FCMWebhookClient = new _FCMWebhookClient();

class _InfluencerReferralCodeClient {

  

  



    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  



  
  
  
  



  

  getAll(pagedRequestVM: OM.PagedRequestVM, router: Router, showSpinner = true) : Promise<OM.PagedResponseOfInfluencerReferralVM> {
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    pushHistoryState(pagedRequestVM, router);
    return CommonServices.defaultGet<OM.PagedResponseOfInfluencerReferralVM>(baseUrl + 'api/InfluencerReferralCode/GetAll', paramsObject, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getByID(identifier : string, showSpinner = true) : Promise<OM.InfluencerReferralVM> {
    return CommonServices.defaultGet<OM.InfluencerReferralVM>(baseUrl + 'api/InfluencerReferralCode/GetByID', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  editInfluencerReferral(model : OM.InfluencerReferralVM, showSpinner = true) : Promise<string> {
    return CommonServices.defaultPost<string>(baseUrl + 'api/InfluencerReferralCode/EditInfluencerReferral', model, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  enableInfluencerReferral(identifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/InfluencerReferralCode/EnableInfluencerReferral', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  disableInfluencerReferral(identifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/InfluencerReferralCode/DisableInfluencerReferral', { identifier }, showSpinner)
  }
}
export let InfluencerReferralCodeClient = new _InfluencerReferralCodeClient();

class _LocalResourceContryClient {

  

  



  
  
  
  

  

  getExtendedCountries(showSpinner = true) : Promise<OM.ExtendedCountry[]> {
    return CommonServices.defaultGet<OM.ExtendedCountry[]>(baseUrl + 'api/LocalResourceContry/GetExtendedCountries', {  }, showSpinner)
  }
}
export let LocalResourceContryClient = new _LocalResourceContryClient();

class _NotificationClient {

  

  



  
  
  
  

  

  getNotification(showSpinner = true) : Promise<OM.NotificationVM[]> {
    return CommonServices.defaultGet<OM.NotificationVM[]>(baseUrl + 'api/Notification/GetNotification', {  }, showSpinner)
  }

  

  



  
  
  
  

  

  readAllNotification(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Notification/ReadAllNotification', {  }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  readNotification(identifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Notification/ReadNotification', { identifier }, showSpinner)
  }

  

  



  
  
  
  

  

  getUnreadNotificationNumber(showSpinner = true) : Promise<number> {
    return CommonServices.defaultGet<number>(baseUrl + 'api/Notification/GetUnreadNotificationNumber', {  }, showSpinner)
  }

  

  



  
  
  
  

  

  getUnreadAffinityNotificationNumber(showSpinner = true) : Promise<number> {
    return CommonServices.defaultGet<number>(baseUrl + 'api/Notification/GetUnreadAffinityNotificationNumber', {  }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  readAllAffinityNotification(chatRoomIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Notification/ReadAllAffinityNotification', { chatRoomIdentifier }, showSpinner)
  }

  

  



  
  
  
  

  

  getAffinityNotification(showSpinner = true) : Promise<{ [key: string]: number; }> {
    return CommonServices.defaultGet<{ [key: string]: number; }>(baseUrl + 'api/Notification/GetAffinityNotification', {  }, showSpinner)
  }
}
export let NotificationClient = new _NotificationClient();

class _PowerBIClient {

  

  



    

    

    


  



  
  
  
  

  

  getUsers(psw : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/PowerBI/GetUsers', { psw }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getUserMatches(psw : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/PowerBI/GetUserMatches', { psw }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getChatRooms(psw : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/PowerBI/GetChatRooms', { psw }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getChatMessages(psw : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/PowerBI/GetChatMessages', { psw }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getDeleteAccountReason(psw : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/PowerBI/GetDeleteAccountReason', { psw }, showSpinner)
  }
}
export let PowerBIClient = new _PowerBIClient();

class _PremiumClient {

  

  



    

    

    


  



  
  
  
  

  

  getAndroidPremium(productIdsContainer : OM.ListStringContainerVM, showSpinner = true) : Promise<OM.PremiumVM[]> {
    return CommonServices.defaultPost<OM.PremiumVM[]>(baseUrl + 'api/Premium/GetAndroidPremium', productIdsContainer, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getAndroidPremium2(productIdsContainer : OM.ListStringContainerVM, showSpinner = true) : Promise<OM.PremiumVM[]> {
    return CommonServices.defaultPost<OM.PremiumVM[]>(baseUrl + 'Premium/GetAndroidPremium', productIdsContainer, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getIosPremium(productIdsContainer : OM.ListStringContainerVM, showSpinner = true) : Promise<OM.PremiumVM[]> {
    return CommonServices.defaultPost<OM.PremiumVM[]>(baseUrl + 'api/Premium/GetIosPremium', productIdsContainer, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getIosPremium2(productIdsContainer : OM.ListStringContainerVM, showSpinner = true) : Promise<OM.PremiumVM[]> {
    return CommonServices.defaultPost<OM.PremiumVM[]>(baseUrl + 'Premium/GetIosPremium', productIdsContainer, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getStripePremium(productIdsContainer : OM.ListStringContainerVM, showSpinner = true) : Promise<OM.PremiumVM[]> {
    return CommonServices.defaultPost<OM.PremiumVM[]>(baseUrl + 'api/Premium/GetStripePremium', productIdsContainer, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getStripePremium2(productIdsContainer : OM.ListStringContainerVM, showSpinner = true) : Promise<OM.PremiumVM[]> {
    return CommonServices.defaultPost<OM.PremiumVM[]>(baseUrl + 'Premium/GetStripePremium', productIdsContainer, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getDetail(identifier : string, showSpinner = true) : Promise<OM.PremiumVM> {
    return CommonServices.defaultGet<OM.PremiumVM>(baseUrl + 'api/Premium/GetDetail', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getDetail2(identifier : string, showSpinner = true) : Promise<OM.PremiumVM> {
    return CommonServices.defaultGet<OM.PremiumVM>(baseUrl + 'Premium/GetDetail', { identifier }, showSpinner)
  }

  

  



  
  
  
  

  

  getActive(showSpinner = true) : Promise<OM.PremiumActiveVM> {
    return CommonServices.defaultGet<OM.PremiumActiveVM>(baseUrl + 'api/Premium/GetActive', {  }, showSpinner)
  }

  

  



  
  
  
  

  

  getActive2(showSpinner = true) : Promise<OM.PremiumActiveVM> {
    return CommonServices.defaultGet<OM.PremiumActiveVM>(baseUrl + 'Premium/GetActive', {  }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  checkPremiumPlan(customerInfoVM : OM.CustomerInfoVM, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Premium/CheckPremiumPlan', customerInfoVM, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  checkPremiumPlan2(customerInfoVM : OM.CustomerInfoVM, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'Premium/CheckPremiumPlan', customerInfoVM, { }, showSpinner)
  }

  

  



  
  
  
  

  

  checkIfUserIsPremium(showSpinner = true) : Promise<boolean> {
    return CommonServices.defaultGet<boolean>(baseUrl + 'api/Premium/CheckIfUserIsPremium', {  }, showSpinner)
  }

  

  



  
  
  
  

  

  checkIfUserIsPremium2(showSpinner = true) : Promise<boolean> {
    return CommonServices.defaultGet<boolean>(baseUrl + 'Premium/CheckIfUserIsPremium', {  }, showSpinner)
  }
}
export let PremiumClient = new _PremiumClient();

class _PremiumPurchasedClient {

  

  



    

    

    


  



  
  
  
  

  

  getUserPremiumPurchasedHistory(userIdentifier : string, showSpinner = true) : Promise<OM.PremiumPurchasedListVM[]> {
    return CommonServices.defaultGet<OM.PremiumPurchasedListVM[]>(baseUrl + 'api/PremiumPurchased/GetUserPremiumPurchasedHistory', { userIdentifier }, showSpinner)
  }
}
export let PremiumPurchasedClient = new _PremiumPurchasedClient();

class _PremiumToClaimClient {

  

  



    

    

    


  



  
  
  
  

  

  claimItem(itemIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/PremiumToClaim/ClaimItem', { itemIdentifier }, showSpinner)
  }

  

  



  
  
  
  

  

  getMyItems(showSpinner = true) : Promise<OM.PremiumToClaimVM[]> {
    return CommonServices.defaultGet<OM.PremiumToClaimVM[]>(baseUrl + 'api/PremiumToClaim/GetMyItems', {  }, showSpinner)
  }
}
export let PremiumToClaimClient = new _PremiumToClaimClient();

class _PreviewQuestionClient {

  

  



    

    

    


  



  
  
  
  

  

  createOrUpdate(previewQuestionVM : OM.PreviewQuestionVM, showSpinner = true) : Promise<string> {
    return CommonServices.defaultPost<string>(baseUrl + 'api/PreviewQuestion/CreateOrUpdate', previewQuestionVM, { }, showSpinner)
  }

  

  



    

    

    

      

    

    

    


  



  
  
  
  

  

  updatePreviewQuestionImage(identifier : string, file : File, progressFn: (prog) => void = null, showSpinner = true) : Promise<void> {
    return CommonServices.uploadFileToUrl<void>(baseUrl + 'api/PreviewQuestion/UpdatePreviewQuestionImage?identifier=' + identifier, file, { }, progressFn, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  



  
  
  
  



  

  getAll(pagedRequestVM: OM.PagedRequestVM, router: Router, showSpinner = true) : Promise<OM.PagedResponseOfPreviewQuestionVM> {
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    pushHistoryState(pagedRequestVM, router);
    return CommonServices.defaultGet<OM.PagedResponseOfPreviewQuestionVM>(baseUrl + 'api/PreviewQuestion/GetAll', paramsObject, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getById(identifier : string, showSpinner = true) : Promise<OM.PreviewQuestionVM> {
    return CommonServices.defaultGet<OM.PreviewQuestionVM>(baseUrl + 'api/PreviewQuestion/GetById', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  publish(identifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/PreviewQuestion/Publish', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  hide(identifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/PreviewQuestion/Hide', { identifier }, showSpinner)
  }

  

  



  
  
  
  

  

  getAllPublished(showSpinner = true) : Promise<OM.PreviewQuestionVM[]> {
    return CommonServices.defaultGet<OM.PreviewQuestionVM[]>(baseUrl + 'api/PreviewQuestion/GetAllPublished', {  }, showSpinner)
  }
}
export let PreviewQuestionClient = new _PreviewQuestionClient();

class _StripeClient {

  

  



  
  
  
  

  

  webhook(showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Stripe/Webhook', null, { }, showSpinner)
  }

  

  



  
  
  
  

  

  getOrCreateUserStripeId(showSpinner = true) : Promise<string> {
    return CommonServices.defaultGet<string>(baseUrl + 'api/Stripe/GetOrCreateUserStripeId', {  }, showSpinner)
  }

  

  



  
  
  
  

  

  getSavedCards(showSpinner = true) : Promise<OM.StripeCardDetailVm[]> {
    return CommonServices.defaultGet<OM.StripeCardDetailVm[]>(baseUrl + 'api/Stripe/GetSavedCards', {  }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  addCardToCustomer(vm : OM.StripeSaveCardVm, showSpinner = true) : Promise<OM.StripeCardDetailVm> {
    return CommonServices.defaultPost<OM.StripeCardDetailVm>(baseUrl + 'api/Stripe/AddCardToCustomer', vm, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  removeCardFromCustomer(paymentMethodId : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Stripe/RemoveCardFromCustomer', { paymentMethodId }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  createSubscriptionIntent(stripeProductPriceId : string, showSpinner = true) : Promise<OM.SubscriptionCreateResponseVm> {
    return CommonServices.defaultGet<OM.SubscriptionCreateResponseVm>(baseUrl + 'api/Stripe/CreateSubscriptionIntent', { stripeProductPriceId }, showSpinner)
  }

  

  



  
  
  
  

  

  getAllAvailableProducts(showSpinner = true) : Promise<OM.ProductVm[]> {
    return CommonServices.defaultGet<OM.ProductVm[]>(baseUrl + 'api/Stripe/GetAllAvailableProducts', {  }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getProductPriceId(productId : string, showSpinner = true) : Promise<string> {
    return CommonServices.defaultGet<string>(baseUrl + 'api/Stripe/GetProductPriceId', { productId }, showSpinner)
  }

  

  



  
  
  
  

  

  getCurrentSubscriptionId(showSpinner = true) : Promise<string> {
    return CommonServices.defaultGet<string>(baseUrl + 'api/Stripe/GetCurrentSubscriptionId', {  }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  confirmSubscriptionPurchase(model : OM.ConfirmSubscriptionPurchaseVm, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Stripe/ConfirmSubscriptionPurchase', model, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  cancelSubscription(model : OM.SubscriptionCancelationModeVm, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Stripe/CancelSubscription', model, { }, showSpinner)
  }
}
export let StripeClient = new _StripeClient();

class _SubscriptionReceiptClient {

  

  



    

    

    


  



  
  
  
  

  

  pOST(model : any[], showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/SubscriptionReceipt/POST', model, { }, showSpinner)
  }
}
export let SubscriptionReceiptClient = new _SubscriptionReceiptClient();

class _TestClient {

  

  



    

    

    


  

    

    

    


  



  
  
  
  

  

  freeLifetimePremium(psw : string, phonenumber : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Test/FreeLifetimePremium', { psw, phonenumber }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  fixAffinitySummary(psw : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Test/FixAffinitySummary', { psw }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  fixGhostingSummary(psw : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Test/FixGhostingSummary', { psw }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  

    

    

    


  



  
  
  
  


  

  testPush(psw : string, title : string, message : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Test/TestPush', { psw, title, message }, showSpinner)
  }
}
export let TestClient = new _TestClient();

class _TryAgainClient {

  

  



  
  
  
  

  

  canTryAgain(showSpinner = true) : Promise<boolean> {
    return CommonServices.defaultGet<boolean>(baseUrl + 'api/TryAgain/CanTryAgain', {  }, showSpinner)
  }

  

  



  
  
  
  

  

  tryAgainAvailable(showSpinner = true) : Promise<number> {
    return CommonServices.defaultGet<number>(baseUrl + 'api/TryAgain/TryAgainAvailable', {  }, showSpinner)
  }

  

  



  
  
  
  

  

  getLastUsed(showSpinner = true) : Promise<Date> {
    return CommonServices.defaultGet<Date>(baseUrl + 'api/TryAgain/GetLastUsed', {  }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  useTryAgain(affinityIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/TryAgain/UseTryAgain', { affinityIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getTryAgainSummary(affinityIdentifier : string, showSpinner = true) : Promise<OM.TryAgainSummaryVM> {
    return CommonServices.defaultGet<OM.TryAgainSummaryVM>(baseUrl + 'api/TryAgain/GetTryAgainSummary', { affinityIdentifier }, showSpinner)
  }
}
export let TryAgainClient = new _TryAgainClient();

class _WaitingListClient {

  

  



    

    

    


  



  
  
  
  

  

  addUserToWaitingList(model : OM.WaitingListUserModelVM, showSpinner = true) : Promise<string> {
    return CommonServices.defaultPost<string>(baseUrl + 'api/WaitingList/AddUserToWaitingList', model, { }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  



  
  
  
  



  

  getAllUserInWaitingList(pagedRequestVM: OM.PagedRequestVM, router: Router, showSpinner = true) : Promise<OM.PagedResponseOfWaitingListUserVM> {
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    pushHistoryState(pagedRequestVM, router);
    return CommonServices.defaultGet<OM.PagedResponseOfWaitingListUserVM>(baseUrl + 'api/WaitingList/GetAllUserInWaitingList', paramsObject, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  rejectUser(waitingListUserIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/WaitingList/RejectUser', { waitingListUserIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  confirmUser(waitingListUserIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/WaitingList/ConfirmUser', { waitingListUserIdentifier }, showSpinner)
  }
}
export let WaitingListClient = new _WaitingListClient();

class _AdminClient {

  

  



  
  
  
  

  

  getAppConfiguration(showSpinner = true) : Promise<OM.SystemConfiguration> {
    return CommonServices.defaultGet<OM.SystemConfiguration>(baseUrl + 'api/Admin/GetAppConfiguration', {  }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  setAppConfiguration(config : OM.SystemConfiguration, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Admin/SetAppConfiguration', config, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  login(model : OM.LanguageCredential, showSpinner = true) : Promise<OM.BaseApiLoginResponse> {
    return CommonServices.defaultPost<OM.BaseApiLoginResponse>(baseUrl + 'api/Admin/Login', model, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  register(model : OM.LanguageCredential, showSpinner = true) : Promise<OM.BaseApiLoginResponse> {
    return CommonServices.defaultPost<OM.BaseApiLoginResponse>(baseUrl + 'api/Admin/Register', model, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  changePassword(newPassword : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Admin/ChangePassword', { newPassword }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  resetConfirmationCode(username : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Admin/ResetConfirmationCode', { username }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  refreshToken(tokens : OM.AuthResponse, showSpinner = true) : Promise<OM.AuthResponse> {
    return CommonServices.defaultPost<OM.AuthResponse>(baseUrl + 'api/Admin/RefreshToken', tokens, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  resetPassword(username : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Admin/ResetPassword', { username }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  

    

    

    


  



  
  
  
  


  

  confirm(loginIdentifier : string, confirmationCode : string, preferredCulture : string, showSpinner = true) : Promise<OM.BaseApiLoginResponse> {
    return CommonServices.defaultGet<OM.BaseApiLoginResponse>(baseUrl + 'api/Admin/Confirm', { loginIdentifier, confirmationCode, preferredCulture }, showSpinner)
  }
}
export let AdminClient = new _AdminClient();

class _AppUserClient {

  

  



  
  
  
  

  

  checkLogin(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/AppUser/CheckLogin', {  }, showSpinner)
  }

  

  



  
  
  
  

  

  getFilter(showSpinner = true) : Promise<OM.FilterVM> {
    return CommonServices.defaultGet<OM.FilterVM>(baseUrl + 'api/AppUser/GetFilter', {  }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  resetConfirmationCode(username : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/AppUser/ResetConfirmationCode', { username }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  

    

    

    


  



  
  
  
  


  

  confirm(loginIdentifier : string, confirmationCode : string, preferredCulture : string, showSpinner = true) : Promise<OM.BaseApiLoginResponse> {
    return CommonServices.defaultGet<OM.BaseApiLoginResponse>(baseUrl + 'api/AppUser/Confirm', { loginIdentifier, confirmationCode, preferredCulture }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  promoCodeAlreadyInserted(loginIdentifier : string, showSpinner = true) : Promise<boolean> {
    return CommonServices.defaultGet<boolean>(baseUrl + 'api/AppUser/PromoCodeAlreadyInserted', { loginIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  insertPromoCode(referralCode : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/AppUser/InsertPromoCode', { referralCode }, showSpinner)
  }

  

  



  
  
  
  

  

  tokenUpgrade(showSpinner = true) : Promise<OM.LoggedUserVM> {
    return CommonServices.defaultGet<OM.LoggedUserVM>(baseUrl + 'api/AppUser/TokenUpgrade', {  }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  changeLanguageAndGetToken(language : string, showSpinner = true) : Promise<string> {
    return CommonServices.defaultGet<string>(baseUrl + 'api/AppUser/ChangeLanguageAndGetToken', { language }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  register(model : OM.LanguageCredentialWithLocation, showSpinner = true) : Promise<OM.BaseApiLoginResponse> {
    return CommonServices.defaultPost<OM.BaseApiLoginResponse>(baseUrl + 'api/AppUser/Register', model, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  login(model : OM.LanguageCredentialWithLocation, showSpinner = true) : Promise<OM.BaseApiLoginResponse> {
    return CommonServices.defaultPost<OM.BaseApiLoginResponse>(baseUrl + 'api/AppUser/Login', model, { }, showSpinner)
  }

  

  



  
  
  
  

  

  getProfileEdit(showSpinner = true) : Promise<OM.ProfileEditVM> {
    return CommonServices.defaultGet<OM.ProfileEditVM>(baseUrl + 'api/AppUser/GetProfileEdit', {  }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getOtherProfile(userIdentifier : string, showSpinner = true) : Promise<OM.ProfileSummaryVM> {
    return CommonServices.defaultGet<OM.ProfileSummaryVM>(baseUrl + 'api/AppUser/GetOtherProfile', { userIdentifier }, showSpinner)
  }

  

  



  
  
  
  

  

  deleteAccount(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/AppUser/DeleteAccount', {  }, showSpinner)
  }

  

  



  
  
  
  

  

  getProfileSettings(showSpinner = true) : Promise<OM.ProfileSettingsVM> {
    return CommonServices.defaultGet<OM.ProfileSettingsVM>(baseUrl + 'api/AppUser/GetProfileSettings', {  }, showSpinner)
  }

  

  



  
  
  
  

  

  getProfileNotificationConfiguration(showSpinner = true) : Promise<OM.ProfileNotificationVM> {
    return CommonServices.defaultGet<OM.ProfileNotificationVM>(baseUrl + 'api/AppUser/GetProfileNotificationConfiguration', {  }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  



  
  
  
  

  

  updateEmailAndNewsletter(email : string, subscribedNewsletter : boolean, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/AppUser/UpdateEmailAndNewsletter', { email, subscribedNewsletter }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  updateMinimumAffinityPercentage(value : number, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/AppUser/UpdateMinimumAffinityPercentage', { value }, showSpinner)
  }

  

  



  
  
  
  

  

  getAppConfiguration(showSpinner = true) : Promise<OM.SystemConfigurationVM> {
    return CommonServices.defaultGet<OM.SystemConfigurationVM>(baseUrl + 'api/AppUser/GetAppConfiguration', {  }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getAppOnboardingConfiguration(address : OM.Address, showSpinner = true) : Promise<OM.OnboardingConfigurationVM> {
    return CommonServices.defaultPost<OM.OnboardingConfigurationVM>(baseUrl + 'api/AppUser/GetAppOnboardingConfiguration', address, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  updateSettings(model : OM.UpdateSettingsVM, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/AppUser/UpdateSettings', model, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  updateFilter(model : OM.FilterVM, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/AppUser/UpdateFilter', model, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  updateProfileDescription(description : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/AppUser/UpdateProfileDescription', { description }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  



  
  
  
  

  

  getAddressFromCoords(latitude : number, longitude : number, showSpinner = true) : Promise<OM.Address> {
    return CommonServices.defaultGet<OM.Address>(baseUrl + 'api/AppUser/GetAddressFromCoords', { latitude, longitude }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getAddressFromPlaceId(placeId : string, showSpinner = true) : Promise<OM.Address> {
    return CommonServices.defaultGet<OM.Address>(baseUrl + 'api/AppUser/GetAddressFromPlaceId', { placeId }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  updateUserPosition(model : OM.UpdateUserPositionVm, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/AppUser/UpdateUserPosition', model, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  confirmOnBoarding(model : OM.ConfirmOnboardingVM, showSpinner = true) : Promise<OM.LoggedUserVM> {
    return CommonServices.defaultPost<OM.LoggedUserVM>(baseUrl + 'api/AppUser/ConfirmOnBoarding', model, { }, showSpinner)
  }

  

  



  
  
  
  

  

  getMyImagesWithAllPercentage(showSpinner = true) : Promise<string[]> {
    return CommonServices.defaultGet<string[]>(baseUrl + 'api/AppUser/GetMyImagesWithAllPercentage', {  }, showSpinner)
  }

  

  



  
  
  
  

  

  checkIfBombAlreadyUsed(showSpinner = true) : Promise<boolean> {
    return CommonServices.defaultGet<boolean>(baseUrl + 'api/AppUser/CheckIfBombAlreadyUsed', {  }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  updateProfileQuestion(questionModel : OM.UploadProfileQuestionVM, showSpinner = true) : Promise<number> {
    return CommonServices.defaultPost<number>(baseUrl + 'api/AppUser/UpdateProfileQuestion', questionModel, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  canUpdateProfileQuestion(questionModel : OM.UploadProfileQuestionVM, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/AppUser/CanUpdateProfileQuestion', questionModel, { }, showSpinner)
  }

  

  



    

    

    

      

    

    

    


  



  
  
  
  

  

  updateProfileQuestionImage(indexQuestion : number, file : File, progressFn: (prog) => void = null, showSpinner = true) : Promise<boolean> {
    return CommonServices.uploadFileToUrl<boolean>(baseUrl + 'api/AppUser/UpdateProfileQuestionImage?indexQuestion=' + indexQuestion, file, { }, progressFn, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  deleteProfileQuestion(questionIndex : number, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/AppUser/DeleteProfileQuestion', { questionIndex }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  setFcmId(fcm : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/AppUser/SetFcmId', { fcm }, showSpinner)
  }

  

  



  
  
  
  

  

  checkIfProfileCompleted(showSpinner = true) : Promise<string> {
    return CommonServices.defaultGet<string>(baseUrl + 'api/AppUser/CheckIfProfileCompleted', {  }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  checkIfReferralCodeIsValid(referralCode : string, showSpinner = true) : Promise<boolean> {
    return CommonServices.defaultGet<boolean>(baseUrl + 'api/AppUser/CheckIfReferralCodeIsValid', { referralCode }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  setProfileOnHoliday(profileOnHoliday : boolean, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/AppUser/SetProfileOnHoliday', { profileOnHoliday }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  



  
  
  
  



  

  getAllAppUsers(pagedRequestVM: OM.PagedRequestVM, router: Router, showSpinner = true) : Promise<OM.PagedResponseOfUserBasicInfoVM> {
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    pushHistoryState(pagedRequestVM, router);
    return CommonServices.defaultGet<OM.PagedResponseOfUserBasicInfoVM>(baseUrl + 'api/AppUser/GetAllAppUsers', paramsObject, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getById(userIdentfiier : string, showSpinner = true) : Promise<OM.AppUserCompleteDetailVM> {
    return CommonServices.defaultGet<OM.AppUserCompleteDetailVM>(baseUrl + 'api/AppUser/GetById', { userIdentfiier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  blockUser(identifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/AppUser/BlockUser', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  deleteUser(identifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/AppUser/DeleteUser', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  changePassword(newPassword : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/AppUser/ChangePassword', { newPassword }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  refreshToken(tokens : OM.AuthResponse, showSpinner = true) : Promise<OM.AuthResponse> {
    return CommonServices.defaultPost<OM.AuthResponse>(baseUrl + 'api/AppUser/RefreshToken', tokens, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  resetPassword(username : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/AppUser/ResetPassword', { username }, showSpinner)
  }
}
export let AppUserClient = new _AppUserClient();

class _InternalUserClient {

  

  



  
  
  
  

  

  tokenUpgrade(showSpinner = true) : Promise<OM.InternalUserVM> {
    return CommonServices.defaultGet<OM.InternalUserVM>(baseUrl + 'api/InternalUser/TokenUpgrade', {  }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  login(model : OM.LanguageCredential, showSpinner = true) : Promise<OM.BaseApiLoginResponse> {
    return CommonServices.defaultPost<OM.BaseApiLoginResponse>(baseUrl + 'api/InternalUser/Login', model, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  register(model : OM.LanguageCredential, showSpinner = true) : Promise<OM.BaseApiLoginResponse> {
    return CommonServices.defaultPost<OM.BaseApiLoginResponse>(baseUrl + 'api/InternalUser/Register', model, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  changePassword(newPassword : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/InternalUser/ChangePassword', { newPassword }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  resetConfirmationCode(username : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/InternalUser/ResetConfirmationCode', { username }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  refreshToken(tokens : OM.AuthResponse, showSpinner = true) : Promise<OM.AuthResponse> {
    return CommonServices.defaultPost<OM.AuthResponse>(baseUrl + 'api/InternalUser/RefreshToken', tokens, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  resetPassword(username : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/InternalUser/ResetPassword', { username }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  

    

    

    


  



  
  
  
  


  

  confirm(loginIdentifier : string, confirmationCode : string, preferredCulture : string, showSpinner = true) : Promise<OM.BaseApiLoginResponse> {
    return CommonServices.defaultGet<OM.BaseApiLoginResponse>(baseUrl + 'api/InternalUser/Confirm', { loginIdentifier, confirmationCode, preferredCulture }, showSpinner)
  }
}
export let InternalUserClient = new _InternalUserClient();

class _QuestionAndAnswerCategoryClient {

  

  



    

    

    


  



  
  
  
  

  

  create(createOrUpdateQuestionCategoryVM : OM.CreateOrUpdateQuestionCategoryVM, showSpinner = true) : Promise<string> {
    return CommonServices.defaultPost<string>(baseUrl + 'api/QuestionAndAnswerCategory/Create', createOrUpdateQuestionCategoryVM, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  update(createOrUpdateQuestionCategoryVM : OM.CreateOrUpdateQuestionCategoryVM, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/QuestionAndAnswerCategory/Update', createOrUpdateQuestionCategoryVM, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  delete(identifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/QuestionAndAnswerCategory/Delete', { identifier }, showSpinner)
  }
}
export let QuestionAndAnswerCategoryClient = new _QuestionAndAnswerCategoryClient();

class _QuestionAndAnswerClient {

  

  



  
  
  
  

  

  getAll(showSpinner = true) : Promise<OM.QuestionAndAnswerVM[]> {
    return CommonServices.defaultGet<OM.QuestionAndAnswerVM[]>(baseUrl + 'api/QuestionAndAnswer/GetAll', {  }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  create(viewModel : OM.CreateOrUpdateQuestionAndAnswerVM, showSpinner = true) : Promise<string> {
    return CommonServices.defaultPost<string>(baseUrl + 'api/QuestionAndAnswer/Create', viewModel, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  update(viewModel : OM.CreateOrUpdateQuestionAndAnswerVM, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/QuestionAndAnswer/Update', viewModel, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  delete(identifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/QuestionAndAnswer/Delete', { identifier }, showSpinner)
  }

  

  



  
  
  
  

  

  getExperienceFaq(showSpinner = true) : Promise<OM.QuestionAndAnswerVM[]> {
    return CommonServices.defaultGet<OM.QuestionAndAnswerVM[]>(baseUrl + 'api/QuestionAndAnswer/GetExperienceFaq', {  }, showSpinner)
  }
}
export let QuestionAndAnswerClient = new _QuestionAndAnswerClient();

class _MatchClient {

  

  



  
  
  
  

  

  getNewMatch(showSpinner = true) : Promise<OM.NewMatchVm> {
    return CommonServices.defaultGet<OM.NewMatchVm>(baseUrl + 'api/Match/GetNewMatch', {  }, showSpinner)
  }

  

  



  
  
  
  

  

  checkIfCanReply(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Match/CheckIfCanReply', {  }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  



  
  
  
  

  

  getMatchDetail(affinityIdentifier : string, replierIdentifier : string, showSpinner = true) : Promise<OM.MatchDetailVm> {
    return CommonServices.defaultGet<OM.MatchDetailVm>(baseUrl + 'api/Match/GetMatchDetail', { affinityIdentifier, replierIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  refuseAffinity(affinityIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Match/RefuseAffinity', { affinityIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getNewMatchInformations(identifier : string, showSpinner = true) : Promise<OM.NewMatchVm> {
    return CommonServices.defaultGet<OM.NewMatchVm>(baseUrl + 'api/Match/GetNewMatchInformations', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  confirmAffinity(model : OM.ConfirmAffinityVM, showSpinner = true) : Promise<string> {
    return CommonServices.defaultPost<string>(baseUrl + 'api/Match/ConfirmAffinity', model, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  replyQuestion(model : OM.ReplyMatchQuestionVm, showSpinner = true) : Promise<OM.NewMatchVm> {
    return CommonServices.defaultPost<OM.NewMatchVm>(baseUrl + 'api/Match/ReplyQuestion', model, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  takeOffAffinity(affinityIdentifier : string, showSpinner = true) : Promise<OM.UserMatchQuestionResponse> {
    return CommonServices.defaultGet<OM.UserMatchQuestionResponse>(baseUrl + 'api/Match/TakeOffAffinity', { affinityIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  takeOffMultipleAffinitiesFromChatRoomIdentifiers(model : OM.TakeOffMultipleAffinitiesVM, showSpinner = true) : Promise<OM.UserMatchQuestionResponse> {
    return CommonServices.defaultPost<OM.UserMatchQuestionResponse>(baseUrl + 'api/Match/TakeOffMultipleAffinitiesFromChatRoomIdentifiers', model, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getNewMatchFromBackoffice(userIdentifier : string, showSpinner = true) : Promise<OM.NewMatchVm> {
    return CommonServices.defaultGet<OM.NewMatchVm>(baseUrl + 'api/Match/GetNewMatchFromBackoffice', { userIdentifier }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  



  
  
  
  




  

  getUserAffinitiesFromBackoffice(pagedRequestVM: OM.PagedRequestWithIdentifierVM, router: Router, showSpinner = true) : Promise<OM.PagedResponseOfBackofficeAffinityListVM> {
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    pushHistoryState(pagedRequestVM, router);
    return CommonServices.defaultGet<OM.PagedResponseOfBackofficeAffinityListVM>(baseUrl + 'api/Match/GetUserAffinitiesFromBackoffice', paramsObject, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  



  
  
  
  



  

  getAffinitiesFromBackoffice(pagedRequestVM: OM.PagedRequestVM, router: Router, showSpinner = true) : Promise<OM.PagedResponseOfBackofficeAffinityListVM> {
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    pushHistoryState(pagedRequestVM, router);
    return CommonServices.defaultGet<OM.PagedResponseOfBackofficeAffinityListVM>(baseUrl + 'api/Match/GetAffinitiesFromBackoffice', paramsObject, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getMatchDetailFromBackoffice(affinityIdentifier : string, showSpinner = true) : Promise<OM.BackofficeAffinityDetailVM> {
    return CommonServices.defaultGet<OM.BackofficeAffinityDetailVM>(baseUrl + 'api/Match/GetMatchDetailFromBackoffice', { affinityIdentifier }, showSpinner)
  }
}
export let MatchClient = new _MatchClient();

class _SecondChanceMatchClient {

  

  



  
  
  
  

  

  getSecondChance(showSpinner = true) : Promise<OM.SecondChanceVM> {
    return CommonServices.defaultGet<OM.SecondChanceVM>(baseUrl + 'api/SecondChanceMatch/GetSecondChance', {  }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  refuseSecondChance(matchIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/SecondChanceMatch/RefuseSecondChance', { matchIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getSecondChanceDetail(identifier : string, showSpinner = true) : Promise<OM.NewMatchVm> {
    return CommonServices.defaultGet<OM.NewMatchVm>(baseUrl + 'api/SecondChanceMatch/GetSecondChanceDetail', { identifier }, showSpinner)
  }
}
export let SecondChanceMatchClient = new _SecondChanceMatchClient();

class _BackofficeFakeProfileClient {

  

  



    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  



  
  
  
  



  

  getAllFakeProfiles(pagedRequestVM: OM.PagedRequestVM, router: Router, showSpinner = true) : Promise<OM.PagedResponseOfFakeProfileListVM> {
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    pushHistoryState(pagedRequestVM, router);
    return CommonServices.defaultGet<OM.PagedResponseOfFakeProfileListVM>(baseUrl + 'api/BackofficeFakeProfile/GetAllFakeProfiles', paramsObject, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getFakeProfileDetail(identifier : string, showSpinner = true) : Promise<OM.FakeProfileDetailVM> {
    return CommonServices.defaultGet<OM.FakeProfileDetailVM>(baseUrl + 'api/BackofficeFakeProfile/GetFakeProfileDetail', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  disable(identifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/BackofficeFakeProfile/Disable', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  publish(identifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/BackofficeFakeProfile/Publish', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  hide(identifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/BackofficeFakeProfile/Hide', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  createOrUpdate(vm : OM.CreateOrUpdateFakeProfileVM, showSpinner = true) : Promise<string> {
    return CommonServices.defaultPost<string>(baseUrl + 'api/BackofficeFakeProfile/CreateOrUpdate', vm, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  updateProfileQuestion(questionModel : OM.UploadFakeProfileQuestionVM, showSpinner = true) : Promise<number> {
    return CommonServices.defaultPost<number>(baseUrl + 'api/BackofficeFakeProfile/UpdateProfileQuestion', questionModel, { }, showSpinner)
  }

  

  



    

    

    

      

    

    

    

      

    

    

    


  



  
  
  
  


  

  updateProfileQuestionImage(indexQuestion : number, fakeProfileIdentifier : string, file : File, progressFn: (prog) => void = null, showSpinner = true) : Promise<void> {
    return CommonServices.uploadFileToUrl<void>(baseUrl + 'api/BackofficeFakeProfile/UpdateProfileQuestionImage?indexQuestion=' + indexQuestion + '&fakeProfileIdentifier=' + fakeProfileIdentifier, file, { }, progressFn, showSpinner)
  }
}
export let BackofficeFakeProfileClient = new _BackofficeFakeProfileClient();

class _EventAdminClient {

  

  



    

    

    


  



  
  
  
  

  

  getEventDetail(eventIdentifier : string, showSpinner = true) : Promise<OM.BaseEventModel> {
    return CommonServices.defaultGet<OM.BaseEventModel>(baseUrl + 'api/EventAdmin/GetEventDetail', { eventIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  editEvent(model : OM.LiveEventDataVM, showSpinner = true) : Promise<OM.BaseEventModel> {
    return CommonServices.defaultPost<OM.BaseEventModel>(baseUrl + 'api/EventAdmin/EditEvent', model, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  editEventSearchPreferences(model : OM.LiveEventSearchPreferencesVM, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/EventAdmin/EditEventSearchPreferences', model, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  publish(eventIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/EventAdmin/Publish', { eventIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  hide(eventIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/EventAdmin/Hide', { eventIdentifier }, showSpinner)
  }

  

  



    

    

    

      

    

    

    

      

    

    

    


  



  
  
  
  


  

  updateEventQuestionImage(indexQuestion : number, eventIdentifier : string, file : File, progressFn: (prog) => void = null, showSpinner = true) : Promise<void> {
    return CommonServices.uploadFileToUrl<void>(baseUrl + 'api/EventAdmin/UpdateEventQuestionImage?indexQuestion=' + indexQuestion + '&eventIdentifier=' + eventIdentifier, file, { }, progressFn, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  updateEventQuestion(questionModel : OM.UploadEventQuestionVM, showSpinner = true) : Promise<number> {
    return CommonServices.defaultPost<number>(baseUrl + 'api/EventAdmin/UpdateEventQuestion', questionModel, { }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  



  
  
  
  



  

  getAll(pagedRequestVM: OM.PagedRequestVM, router: Router, showSpinner = true) : Promise<OM.PagedResponseOfBaseEventModel> {
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    pushHistoryState(pagedRequestVM, router);
    return CommonServices.defaultGet<OM.PagedResponseOfBaseEventModel>(baseUrl + 'api/EventAdmin/GetAll', paramsObject, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  



  
  
  
  

  

  deleteProfileQuestion(questionIndex : number, eventIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/EventAdmin/DeleteProfileQuestion', { questionIndex, eventIdentifier }, showSpinner)
  }
}
export let EventAdminClient = new _EventAdminClient();

class _LiveEventClient {

  

  



  
  
  
  

  

  checkForEvent(showSpinner = true) : Promise<OM.WithDistanceResultOfEventMatchVm> {
    return CommonServices.defaultGet<OM.WithDistanceResultOfEventMatchVm>(baseUrl + 'api/LiveEvent/CheckForEvent', {  }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getNewMatchInformations(identifier : string, showSpinner = true) : Promise<OM.EventMatchVm> {
    return CommonServices.defaultGet<OM.EventMatchVm>(baseUrl + 'api/LiveEvent/GetNewMatchInformations', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  replyQuestion(model : OM.ReplyEventQuestionVm, showSpinner = true) : Promise<OM.EventMatchVm> {
    return CommonServices.defaultPost<OM.EventMatchVm>(baseUrl + 'api/LiveEvent/ReplyQuestion', model, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  checkIn(eventIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/LiveEvent/CheckIn', { eventIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  checkIfAlreadyCheckedIn(eventIdentifier : string, showSpinner = true) : Promise<boolean> {
    return CommonServices.defaultGet<boolean>(baseUrl + 'api/LiveEvent/CheckIfAlreadyCheckedIn', { eventIdentifier }, showSpinner)
  }

  

  



  
  
  
  

  

  getAll(showSpinner = true) : Promise<OM.AppUserCheckedInVM[]> {
    return CommonServices.defaultGet<OM.AppUserCheckedInVM[]>(baseUrl + 'api/LiveEvent/GetAll', {  }, showSpinner)
  }

  

  



  
  
  
  

  

  getMyEvents(showSpinner = true) : Promise<OM.EventMatchResumeVM[]> {
    return CommonServices.defaultGet<OM.EventMatchResumeVM[]>(baseUrl + 'api/LiveEvent/GetMyEvents', {  }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  getEventDetail(matchIdentifier : string, showSpinner = true) : Promise<OM.EventMatchDetailVM> {
    return CommonServices.defaultGet<OM.EventMatchDetailVM>(baseUrl + 'api/LiveEvent/GetEventDetail', { matchIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  subscribeToEvent(eventIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/LiveEvent/SubscribeToEvent', { eventIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  unsubscribeToEvent(eventIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/LiveEvent/UnsubscribeToEvent', { eventIdentifier }, showSpinner)
  }
}
export let LiveEventClient = new _LiveEventClient();

class _LocalizationClient {

  

  



  
  
  
  

  

  getAppDictionary(showSpinner = true) : Promise<OM.LocalizedEntity[]> {
    return CommonServices.defaultGet<OM.LocalizedEntity[]>(baseUrl + 'api/Localization/GetAppDictionary', {  }, showSpinner)
  }

  

  



  
  
  
  

  

  getAll(showSpinner = true) : Promise<OM.LocalizedEntity[]> {
    return CommonServices.defaultGet<OM.LocalizedEntity[]>(baseUrl + 'api/Localization/GetAll', {  }, showSpinner)
  }

  

  



  
  
  
  

  

  getEnabledLanguages(showSpinner = true) : Promise<string[]> {
    return CommonServices.defaultGet<string[]>(baseUrl + 'api/Localization/GetEnabledLanguages', {  }, showSpinner)
  }

  

  



  
  
  
  

  

  getSupportedLanguages(showSpinner = true) : Promise<string[]> {
    return CommonServices.defaultGet<string[]>(baseUrl + 'api/Localization/GetSupportedLanguages', {  }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  saveLocalizedValue(item : OM.KeyValuePairOfStringAndString, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Localization/SaveLocalizedValue', item, { }, showSpinner)
  }

  

  



    

    

    


  



  
  
  
  

  

  editLocalizedValue(value : OM.LocalizedEntity, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Localization/EditLocalizedValue', value, { }, showSpinner)
  }
}
export let LocalizationClient = new _LocalizationClient();

interface FileParameter {
    data: any;
    fileName: string;
}

interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}

function pushHistoryState(pagedRequestVM: OM.PagedRequestVM | OM.PagedRequestWithIdentifierVM, router: Router) {
    // Ottenere l'URL corrente
    var route = router.currentRoute.value;
    var query = { ...route.query };

    delete query["paging.currentPage"];
    delete query["paging.itemsPerPage"];
    delete query["paging.skip"];
    delete query["paging.take"];
    delete query["sortBy.propertyName"];
    delete query["sortBy.ascending"];
    delete query["sortBy.ascending"];
    
    if(typeof pagedRequestVM == typeof OM.PagedRequestWithIdentifierVM)
        delete query["identifier"];

    Object.keys(query)
        .filter((x) => x.startsWith("filter["))
        .forEach((key) => {
            delete query[key];
        });

    if (pagedRequestVM.paging != null) {
        query["paging.currentPage"] = pagedRequestVM.paging.currentPage.toString();
        query["paging.itemsPerPage"] = pagedRequestVM.paging.itemsPerPage.toString();
        query["paging.skip"] = pagedRequestVM.paging.skip.toString();
        query["paging.take"] = pagedRequestVM.paging.take.toString();
    }

    if (pagedRequestVM.sortBy != null) {
        query["sortBy.propertyName"] = pagedRequestVM.sortBy.propertyName.toString();
        query["sortBy.ascending"] = pagedRequestVM.sortBy.ascending.toString();
    }

    if((<OM.PagedRequestWithIdentifierVM>pagedRequestVM).identifier)
        query["identifier"] = (<OM.PagedRequestWithIdentifierVM>pagedRequestVM).identifier.toString();

    Object.entries(pagedRequestVM.filter).forEach(([key, values]) => {
        var count = 0;

        values.forEach((value) => {
            if (value) {
                query[`filter[${key}]`] = value;
                // query[`filter_${key.replace('.', '_')}`] = value;
            }
        });
    });

    router
        .push({
            path: route.path,
            query: {
                ...query,
            },
        })
        .then((err) => {
            // console.error(err);
        });
}

function getPagedRequestParamsObject(pagedRequestVM: OM.PagedRequestVM | OM.PagedRequestWithIdentifierVM) {
    var paramsObject: any = {};
  
    if(pagedRequestVM.filter && Object.keys(pagedRequestVM.filter).length > 0){
      Object.entries(pagedRequestVM.filter)
      .forEach(([key, values]) => {
        values.forEach((value) => {
          if (value) {
            paramsObject[`filter[${key}]`] = value;
            // query[`filter_${key.replace('.', '_')}`] = value;
          }
        });
      });
    }
  
    if((<OM.PagedRequestWithIdentifierVM>pagedRequestVM).identifier)
      paramsObject.identifier = (<OM.PagedRequestWithIdentifierVM>pagedRequestVM).identifier.toString();
    
    if (pagedRequestVM.paging) {
        paramsObject["paging.currentPage"] = pagedRequestVM.paging.currentPage;
        paramsObject["paging.itemsPerPage"] = pagedRequestVM.paging.itemsPerPage;
        paramsObject["paging.skip"] = pagedRequestVM.paging.skip;
        paramsObject["paging.take"] = pagedRequestVM.paging.take;
    }
  
    if (pagedRequestVM.sortBy) {
        paramsObject["sortBy.propertyName"] = pagedRequestVM.sortBy.propertyName;
        paramsObject["sortBy.ascending"] = pagedRequestVM.sortBy.ascending;
    }
  
    return paramsObject;
  }